import React from 'react';
import { NavLink } from 'react-router-dom'
import { CloseIcon } from '../Icons/Icons';
import classnames from 'classnames';

import "./popupnavigation.scss";
import { connect } from 'react-redux';
import {logoutAction} from "~/redux/actions/auth";
import { setPopupNavigationStatus } from '../../redux/actions/general';
import TextTranslate from '../TextTranslate/TextTranslate';

function PopupNavigation (props) {

	function hidePopupNavigation () {
		props.dispatch(setPopupNavigationStatus(false))
	}
	
	const handleLogoutUser = () => {
		props.dispatch(setPopupNavigationStatus(false))
        props.dispatch(logoutAction());
	};

	return (
		<div className={classnames([
			"popup-navigation",
			{
				'open': props.popupNavigationOpen
			}
		])}>
			<ul>
				<li>
					<NavLink to="/faq" onClick={hidePopupNavigation}>
						<TextTranslate name="word-faq" fallback="FAQ"/>
					</NavLink>
				</li>
				<li>
					<NavLink to="/contact" onClick={hidePopupNavigation}>
						<TextTranslate name="word-contact-us" fallback="Contact Us"/>
					</NavLink>
				</li>
				{/* <li>
					<NavLink to="/terms" onClick={hidePopupNavigation}>
						<TextTranslate name="word-terms-conditions" fallback="Terms & Conditions" />
					</NavLink>
				</li> */}
				<li>
					<a href="https://www.neom.com/en-us/privacy-policy" target="_blank" onClick={hidePopupNavigation}>
						<TextTranslate name="word-privacy-policy" fallback="Privacy Policy" />
					</a>
				</li>
				{/* <li>
					<NavLink to="/terms/cookie-policy" onClick={hidePopupNavigation}>
						<TextTranslate name="word-cookie-policy" fallback="Cookie Policy" />
					</NavLink>
				</li> */}
				<li>
					<a className="btn" onClick={handleLogoutUser}>
						<TextTranslate name="word-logout" fallback="Log out"/>
					</a>
				</li>
			</ul>

			<div className="close-navigation" onClick={hidePopupNavigation}>
				<CloseIcon />
			</div>
		</div>
	)
}

const mapStateToProps = (state) => ({
	popupNavigationOpen: state.general.popupNavigationOpen
})

export default connect(mapStateToProps)(PopupNavigation);